<template>
    <v-list two-line class="pa-0">
        <v-list-item>
            <v-list-item-action v-if="icon">
                <v-icon color="indigo">{{icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-action v-if="avatarSrc">
                <v-avatar>
                    <v-img :src="avatarSrc" @click="actionClick"></v-img>
                </v-avatar>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-subtitle style="font-size: 12px;user-select: text;">{{title}}</v-list-item-subtitle>
                <v-list-item-title style="font-size: 17px; user-select: text;">{{sub_title}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider :inset="inset" v-if="divider"></v-divider>
    </v-list>
</template>

<script>
    export default {
        name: "ListItemDetail",
        props: {
            title: {
                type: [String, Number, Boolean],
                default: false
            },
            sub_title: {
                type: [String, Number, Boolean],
                default: false
            },
            icon: {
                type: [String],
                default: ''
            },
            divider: {
                type: [Boolean],
                default: false
            },
              inset: {
                type: [Boolean],
                default: false
            },
            avatarSrc: {
                type: [String],
                default: ''
            }
        },
        methods: {
            actionClick() {
                this.$emit('actionClick')
            }
        }
    }
</script>

<style scoped>

</style>
